export const meetingConstants = {
  BASE_PATH: '/meetings/:account_id/meeting-id',
  API_BASE_PATH: 'v1/building_profile/:account_id/meeting_registers',
  GET_CURRENT_MEETING: 'GET_CURRENT_MEETING',
  SET_CURRENT_MEETING_LOADING: 'SET_CURRENT_MEETING_LOADING',
  GET_MEETINGS: 'GET_MEETINGS',
  SET_MEETINGS_LOADING: 'SET_MEETINGS_LOADING',
  SET_MEETING_ERROR: 'UPDATE_MEETING_ERROR',
  SHOW_SEO: {
    title: 'Your Meeting',
    description: 'Your Meeting',
  },
};
